import ValidationHelper from '../ValidationHelper';
import { validateField } from '../ValidationField';
var CCFIELDS = ValidationHelper.CCFIELDS,
  FIELD_VALIDATION_MAP = ValidationHelper.FIELD_VALIDATION_MAP;
var fieldName = CCFIELDS.CARDHOLDER_NAME;
var validations = FIELD_VALIDATION_MAP[fieldName];

/**
 * validates cardholder name in a payment form
 * @param formData
 * @returns {FormFieldValidationResponse} object indicating the validation result
 */
var validate = function validate(formData) {
  var trim = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var field = formData[fieldName];

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (field !== undefined) {
    return validateField({
      fieldName: fieldName,
      value: field.value,
      validations: validations,
      trim: trim
    });
  }
  return {
    name: fieldName,
    value: '',
    error: ''
  };
};
export default {
  validate: validate
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/business/validators/fieldValidators/CardholderNameValidator.js
// module id = 3501
// module chunks = 11